// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__3a3lh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/UI/Backdrop/Backdrop.css
// module id = 113
// module chunks = 3